import Details from '../../../../assets/src/js/classes/Details';

import '../sass/faqs.scss';

(() => {
    const $faqsBlocks = document.querySelectorAll('.faqs');

    if (!$faqsBlocks) return;

    $faqsBlocks.forEach($faqs => {
        const $dropdowns = $faqs.querySelectorAll('.faqs__dropdown');

        const initDropdowns = () => {
            if (!$dropdowns) return;

            $dropdowns.forEach($dropdown => {
                new Details($dropdown);
            });
        };

        initDropdowns();
    });
})();
